<template>
    <v-dialog
            v-model="isDialogOpen"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            content-class="editing-dialog not-vertical-scroll"
    >
        <v-toolbar
                flat
                dark
                class="main--yellow"
        >
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn text @click.native="$emit('close')">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card>
            <v-container class="app-container">
                <v-card-title class="justify-center grey--text">{{ productName }}</v-card-title>
                <v-divider class="my-2"></v-divider>
                <v-row>
                    <v-col cols="12" md="4" class="pr-2">
                        <geo-search
                                :label="$t('settlement')"
                                @geo-change="geoChange"
                        ></geo-search>
                    </v-col>
                    <v-col cols="12" md="4" class="pr-2">
                        <v-text-field
                                v-model="quantity"
                                :label="$t('quantity')"
                                color="orange lighten-2"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4" class="pr-2">
                        <v-menu
                                v-model="dateMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        v-model="date"
                                        label="Picker without buttons"
                                        readonly
                                        v-on="on"
                                        :label="$t('arriveDate')"
                                        color="orange lighten-2"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                    v-model="date"
                                    @input="dateMenu = false"
                                    :locale="language"
                                    header-color="orange lighten-2"
                                    color="orange lighten-2"
                                    :min="currentDate"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" class="pt-2 pt-md-12">
                        <v-textarea
                                outlined
                                v-model="messageText"
                                :label="$t('messageText')"
                                color="orange lighten-2"
                        ></v-textarea>
                    </v-col>
                </v-row>
                <div class="d-flex justify-end">
                    <v-btn class="my-4 text--main-yellow" text @click="send">
                        {{ $t('send') }}
                    </v-btn>
                </div>
            </v-container>
        </v-card>
        <snack-general :snack-data="snackData"></snack-general>
    </v-dialog>
</template>

<script>
    import DialogRemote from '../../../app-front/mixins/DialogRemote';
    import GeoSearch from '../../../general/geo/search';
    import MessagesService from '../../../app-front/services/api/MessagesService';
    import SnackGeneral from '../../../app-front/components/snacks/SnackGeneral';

    export default {
        name: "ProductPriceDialog",
        props:['product'],
        mixins:[DialogRemote],
        components:{GeoSearch, SnackGeneral},
        data(){
            return {
                date: null,
                dateMenu: false,
                geo: null,
                message: null,
                messageText: null,
                quantity: null,
                snackData: {
                    isOpen: false,
                    color: null,
                    text: null
                },
                currentDate: new Date().toISOString().substr(0, 10),
            }
        },
        computed: {
            productId() {
                return this.product ? this.product.id : null;
            },
            productName() {
                return this.product ? this.product.productName : '';
            },
            productSystemName() {
                return this.product ? this.product.productSystemName : '';
            },
            language() {
                if (this.$store.state.language.appLanguage === 'ua') {
                    return 'uk';
                }
                if (this.$store.state.language.appLanguage === 'ru') {
                    return 'ru';
                }
            }
        },
        methods: {
            geoChange(geo) {
                this.geo = geo;
            },
            send() {
                const params = {
                    categoryId: this.product.category.id,
                    systemName: this.productSystemName,
                    message: this.messageText,
                    quantity: this.quantity,
                    date: this.date,
                    geo: this.geo
                };
                this.$emit('close');
                MessagesService.productPriceMessage(params)
                    .then(res => {
                        this.snackData = {
                            isOpen: true,
                            color: 'main--black',
                            text: this.$t('messageSent')
                        };
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
        }
    }
</script>

<style scoped>

</style>
